/**
 * Compose the E.164 value Firebase receives from the dial and national-number
 * fields. Country metadata handles plans whose domestic form cannot be
 * normalized by removing a leading zero; the explicit dial remains authoritative.
 */
export function composeE164(country, nationalNumber, dial) {
    const dialDigits = String(dial || '').replace(/\D/g, '');
    const typedNational = String(nationalNumber || '').replace(/\D/g, '');
    let nationalDigits = typedNational;

    if (country && country.numberPlan === 'argentina') {
        const domesticMobile = typedNational.match(/^0(\d{2,4})15(\d{6,8})$/);
        if (domesticMobile && domesticMobile[1].length + domesticMobile[2].length === 10) {
            nationalDigits = '9' + domesticMobile[1] + domesticMobile[2];
        } else {
            nationalDigits = typedNational.replace(/^0+/, '');
        }
    } else if (!(country && country.nationalPrefixSignificant)) {
        const nationalLengths = (country && country.nationalLengths) || [];
        const hasNationalLength = (length) => !nationalLengths.length
            || nationalLengths.includes(length);
        let matchedConfiguredPrefix = false;

        for (const selectionPrefix of (country && country.carrierSelectionPrefixes) || []) {
            for (const carrierCode of country.carrierCodes || []) {
                const prefix = selectionPrefix + carrierCode;
                if (typedNational.startsWith(prefix)
                    && hasNationalLength(typedNational.length - prefix.length)) {
                    nationalDigits = typedNational.slice(prefix.length);
                    matchedConfiguredPrefix = true;
                    break;
                }
            }
            if (matchedConfiguredPrefix) {
                break;
            }
        }

        if (!matchedConfiguredPrefix && country && country.nationalPrefixes) {
            for (const prefix of country.nationalPrefixes) {
                if (typedNational.startsWith(prefix)
                    && hasNationalLength(typedNational.length - prefix.length)) {
                    nationalDigits = typedNational.slice(prefix.length);
                    matchedConfiguredPrefix = true;
                    break;
                }
            }
        }

        if (!matchedConfiguredPrefix && !(country && country.nationalPrefixes)) {
            nationalDigits = typedNational.replace(/^0+/, '');
        }
    }

    return '+' + dialDigits + nationalDigits;
}

export function splitInternationalNumber(value, selectedDial, isPaste, findCountry) {
    const raw = String(value || '').trim();
    const marked = /^(\+|00)/.test(raw);
    const digits = raw.replace(/^00/, '').replace(/\D/g, '');
    if (!digits) return null;

    if (!marked) {
        if (!isPaste) return null;

        const dial = String(selectedDial || '').replace(/\D/g, '');
        const tooLongForNanp = dial === '1' && digits.length > 10;
        const tooLongForE164 = dial.length + digits.length > 15;
        if (!tooLongForNanp && !tooLongForE164) return null;
    }

    const country = findCountry(digits);
    if (!country) return null;

    return {
        country,
        nationalNumber: digits.slice(country.dial.length),
    };
}
